<template>
  <div class="opendoor">
    <div class="header">
      <div class="title">多种开门方式 生活更便捷</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="list">
        <div class="item" v-for="item in opendoorList" :key="item.id">
          <img :src="item.logo" alt="" />
          <div>{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import opendoor1 from "../../../../assets/programme/opendoor1.png";
import opendoor2 from "../../../../assets/programme/opendoor2.png";
import opendoor3 from "../../../../assets/programme/opendoor3.png";
import opendoor4 from "../../../../assets/programme/opendoor4.png";
import opendoor5 from "../../../../assets/programme/opendoor5.png";

export default {
  setup() {
    return reactive({
      opendoorList: [
        {
          id: 1,
          title: "密码开锁",
          logo: opendoor1,
        },
        {
          id: 2,
          title: "指纹开门",
          logo: opendoor2,
        },
        {
          id: 3,
          title: "扫码开门",
          logo: opendoor3,
        },
        {
          id: 4,
          title: "IC卡开门",
          logo: opendoor4,
        },
        {
          id: 5,
          title: "人脸识别",
          logo: opendoor5,
        },
      ],
    });
  },
};
</script>

<style scoped>
.opendoor {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body .list {
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
}

.body .list .item {
    text-align: center;
    overflow: hidden;
}
.body .list .item:hover img {
  animation: experienceHover 1s;
}
@keyframes experienceHover {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
.body .list .item img {
    width: 220px;
}
.body .list .item div {
    margin-top: 30px;
}
</style>
